import React from 'react';
import { observer } from 'mobx-react';
import ProfileLayout from './components/ProfileLayout';
import MailNewsSubscriptionForm from './components/MailNewsSubscriptionForm';
import { useMailNewsSubscriptionSettings } from './hooks/useMailNewsSubscriptionSettings';

const AccountSettingScreen = observer(() => {
    const { settings, handleToggle, handleSave, isSaving } = useMailNewsSubscriptionSettings();

    return (
        <ProfileLayout>
            <div className="detail-count-info-right">
                <div className="title-title">
                    <h2 className="title-2">メールニュース受信設定</h2>
                </div>

                <MailNewsSubscriptionForm
                    settings={settings}
                    onToggle={handleToggle}
                    onSave={handleSave}
                    isSaving={isSaving}
                    tabModifierClass="mail-settings-tab--account"
                />
            </div>
        </ProfileLayout>
    );
});

export default AccountSettingScreen;
